import React from "react";
import moment from "moment";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import useDictionary from "@ui/hooks/useDictionary";
import { size } from "./size";
import { IProps } from "./IProps";

const Component: React.FC<IProps> = ({
    lang,
    label,
    id,
    timezone,
    value,
    onChange,
}) => {
    const getWord = useDictionary();
    const _label = getWord(label);
    const getInput = (params: TextFieldProps) => {
        const props = {
            ...params,
            className: "date-time-input",
            InputProps: {
                ...params.InputProps,
                placeholder: "",
                classes: {
                    input: "date-time-input__text",
                },
            },
            InputLabelProps: {
                ...params.InputLabelProps,
                classes: {
                    root: "date-time-input__label",
                },
            },
            label: _label,
            id,
            size: "small" as size,
        };
        return (
            <>
                <TextField {...props} />
            </>
        );
    };

    if (lang === "ru") {
        moment.updateLocale("ru", {
            weekdays: [
                "Воскресенье",
                "Понедельник",
                "Вторник",
                "Среда",
                "Четверг",
                "Пятница",
                "Суббота",
            ],
            weekdaysShort: ["ВС", "ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ"],
        });
    } else {
        moment.updateLocale("en", {
            weekdays: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
            ],
            weekdaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        });
    }

    let fromLocalTz;
    // if (value.utcOffset() == null) {
    //     value.utcOffset() === 1;
    // } else {
    //     fromLocalTz = value.utcOffset();
    // }

    if (value != null) {
        if (value.utcOffset() == null) {
            value.utcOffset(1); 
        } else {
            fromLocalTz = value.utcOffset();
        }
    } else {
        console.error("value is null or undefined");
        fromLocalTz = 0; 
    }

    //const fromLocalTz = value.utcOffset();

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} locale={lang}>
            <DateTimePicker
                renderInput={getInput}
                inputFormat="DD.MM.YYYY HH:mm"
                mask="__.__.____ __:__"
                value={value?.add(fromLocalTz, "m").add(timezone, "m")}
                onChange={onChange}
                ampm={false}
                toolbarTitle={getWord("timeAndDatePickerTitle")}
            />
        </LocalizationProvider>
    );
};

const DateTimeInputComponent = React.memo(Component);

export default DateTimeInputComponent;
